(function() {
  const currentScript = document.currentScript;
  const shopifyUrl = currentScript.dataset.url;
  const isAuthenticated = `${currentScript.dataset.authenticated}` === 'true';

  document.addEventListener('DOMContentLoaded', function() {
    // Helpers
    function generateState() {
      return Math.random().toString(36).substring(2, 15);
    }

    function generateCodeVerifier() {
      const array = new Uint8Array(32);
      window.crypto.getRandomValues(array);
      return btoa(String.fromCharCode.apply(null, array))
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=/g, '');
    }
    
    // Implementations
    function startLogin(buttonId = null) {
      // Set button styling
      const button = document.querySelector(`button[data-sso-login-id="${buttonId}"]`);
      if (button) {
        button.classList.add('loading');
      }

      // Create state object
      const state = generateState();
      const codeVerifier = generateCodeVerifier();
      const stateObject = {
        stateValue: state,
        codeVerifier: codeVerifier
      };

      // Set SSO Referrer
      try {
        const referrerPath = window.location.pathname;
        localStorage.setItem('delta_sso_referrer', referrerPath)
        console.info('SSO Login: Referrer set successfully:', referrerPath);
      } catch (error) {
        console.error('SSO Login: localStorage is not available:', error);
      }

      // Set SSO State
      try {
        localStorage.setItem('delta_sso_state', JSON.stringify(stateObject));
        console.info('SSO Login: State and code verifier stored successfully:', stateObject);
        const encodedState = btoa(JSON.stringify(stateObject));
        if (button) {
          button.classList.remove('loading');
        }
        window.location.href = `https://initiatedeltalogin-udlhlnwylq-uc.a.run.app?state=${encodeURIComponent(encodedState)}`;
      } catch (error) {
        // Unset button styling
        if (button) {
          button.classList.remove('loading');
        }
        console.error('SSO Login: localStorage is not available:', error);
        alert('Your browser settings may prevent this app from working correctly. Please enable localStorage or try a different browser.');
      }
    }

    function verifyStateAndRedirect(receivedState, multipassToken) {
      try {
        const storedReferrerPath = localStorage.getItem('delta_sso_referrer');
        const storedStateObj = JSON.parse(localStorage.getItem('delta_sso_state'));
        const receivedStateObj = JSON.parse(atob(receivedState));

        if (storedStateObj.stateValue === receivedStateObj.stateValue) {
          console.info('SSO Login: State verified successfully');

          // Authenticate with Shopify Multipass token
          const encodedToken = encodeURIComponent(multipassToken);
          fetch(`${shopifyUrl}/account/login/multipass/${encodedToken}`)
            .then(function() {
              // Remove referrer from local storage
              localStorage.removeItem('delta_sso_referrer');
            })
            .then(function() {
              // Redirect to referrer
              if (storedReferrerPath) {
                window.location.href = storedReferrerPath;
              } else {
                window.location.href = '/';
              }
            });
        } else {
          console.error('SSO Login: State verification failed');
          alert('Authentication failed. Please try again.');
        }
      } catch (error) {
        console.error('SSO Login: Error verifying state:', error);
        alert('Authentication process error. Please try again.');
      } finally {
        localStorage.removeItem('delta_sso_state');
      }
    }

    // Init
    function initializeLogin() {
      // Set up login buttons
      const loginButtons = document.querySelectorAll('button[data-sso-login-id]');
      for (let i = 0; i < loginButtons.length; i++) {
        loginButtons[i].addEventListener('click', function() {
          startLogin(loginButtons[i].dataset.ssoLoginId);
        });
      }

      // Check if we're returning from authentication
      const urlParams = new URLSearchParams(window.location.search);
      const state = urlParams.get('state');
      const multipassToken = urlParams.get('multipassToken');
      const isReturningFromAuth = state && multipassToken;
      if (isReturningFromAuth) {
        verifyStateAndRedirect(state, multipassToken);
      }

      // Check if we're on /account/login page
      const isLoginPage = window.location.href.includes('/account/login');
      if (isLoginPage) {
        if (isAuthenticated) {
          window.location.href = '/account';
        } else {
          startLogin();
        }
      }
    }

    // Main
    initializeLogin();
  });
})();